<section
    class="tw-flex tw-flex-col tw-w-full tw-h-[550px] tw-max-h-[90vh] tw-px-6 tw-py-4 md:tw-max-w-[850px] md:tw-min-w-[614px] lg:tw-min-w-[819px] xl:tw-min-w-[850px]"
>
    <div class="tw-flex tw-justify-end tw-w-full tw-mb-4">
        <mat-icon class="tw-cursor-pointer tw-text-[28px]" [mat-dialog-close]>
            close
        </mat-icon>
    </div>
    <div
        class="tw-flex tw-justify-between tw-flex-col lg:tw-flex-row tw-flex-wrap tw-items-center"
    >
        <div class="tw-flex tw-flex-col tw-gap-[2px] tw-w-full lg:tw-w-auto">
            <div class="tw-text-[#003A70] tw-font-bold tw-text-lg">
                <div *ngIf="branch; else noBranchSelected">
                    <p>{{ branch }}</p>
                </div>
                <ng-template #noBranchSelected>
                    {{ "SELECT_BRANCH.SELECT_A_BRANCH" | translate }}
                </ng-template>
            </div>
            <div *ngIf="!branch" class="tw-text-[#6D7A87] tw-font-semibold">
                {{
                    "SELECT_BRANCH.ONLY_ONE_BRANCH_IS_TO_BE_SELECTED"
                        | translate
                }}
            </div>
        </div>
        <div
            class="tw-content-center tw-relative tw-gap-2 tw-rounded-xl tw-h-[49.5px] tw-w-full tw-mt-5 lg:tw-w-auto lg:tw-mt-0"
            [ngClass]="{
                'tw-bg-[rgba(198,204,214,0.15)]': !searchInput,
                'tw-border tw-bg-white': searchInput
            }"
        >
            <div class="tw-px-3 tw-flex tw-items-center tw-gap-2">
                <img
                    *ngIf="!searchInput"
                    src="../../../../../../assets/images/Search.svg"
                    alt="Search"
                    height="21px"
                    width="21px"
                />
                <input
                    id="searchInput"
                    class="tw-flex-1 tw-bg-transparent tw-font-bold tw-text-[16px] tw-text-[#003A70]"
                    placeholder="{{ 'SELECT_BRANCH.CITY' | translate }}, {{
                        'SELECT_BRANCH.POST_CODE' | translate
                    }}"
                    [(ngModel)]="searchInput"
                    (keydown.enter)="onKeyPress($event)"
                    (keydown.tab)="onKeyPress($event)"
                    (focus)="onFocusSearchInput()"
                    (keyup)="onSearchBranch(searchInput)"
                />
                <img
                    *ngIf="!searchInput"
                    src="../../../../../../assets/images/Location.svg"
                    alt="Location"
                    height="21px"
                    width="21px"
                />
                <div
                    *ngIf="searchInput"
                    class="tw-flex tw-bg-[rgba(198,204,214,0.15)] tw-p-1 tw-rounded-full tw-cursor-pointer"
                >
                    <img
                        src="../../../../../../assets/images/Close.svg"
                        alt="Close"
                        (click)="clearSearchInput()"
                        height="15px"
                        width="16px"
                    />
                </div>
            </div>
            <div
                *ngIf="searchInput && branchSuggestion?.length"
                id="branchSuggestion"
                class="tw-absolute tw-w-full md:tw-w-[493px] tw-top-full tw-mt-2 tw-flex-shrink-0 tw-rounded-[16px] tw-p-[16px] tw-border tw-border-[rgba(216,216,216,0.5)] tw-bg-white tw-shadow-[2px_4px_16px_0px_rgba(163,148,131,0.04)] tw-z-10"
                style="
                    max-height: 203px;
                    overflow-y: auto;
                    scrollbar-width: none;
                "
            >
                <div
                    *ngFor="let branch of branchSuggestion"
                    class="tw-cursor-pointer tw-p-1 tw-hover:bg-gray-100"
                >
                    <div class="tw-flex" (click)="selectAutoSuggestion(branch)">
                        <img
                            src="../../../../../../assets/images/Arrow.svg"
                            alt="Arrow"
                        />
                        <div
                            class="tw-font-figtree tw-text-lg tw-font-semibold tw-leading-[40px] tw-pl-5 tw-text-[rgba(109,122,135,0.70)]"
                            [innerHTML]="
                                highlightText(
                                    branch.ptc + ' ' + branch.city,
                                    searchInput
                                )
                            "
                        ></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="tw-relative tw-w-full lg:tw-w-[30%]">
            <button
                (click)="toggleDropdown($event)"
                class="tw-flex tw-items-center tw-justify-between tw-border tw-rounded-xl tw-px-3 tw-h-[49.5px] tw-w-full tw-mt-5 lg:tw-mt-0 tw-bg-[#FBFBFB]"
            >
                <div
                    class="tw-bg-transparent tw-font-bold tw-text-lg tw-text-[#003A70]"
                >
                    {{ selectedState || "State" }}
                </div>
                <img
                    [ngClass]="{ 'tw-rotate-180': isStateDropdownOpen }"
                    src="../../../../../../assets/images/Arrow_Down.svg"
                    alt="Arrow_Down"
                    width="11"
                    height="6"
                />
            </button>
            <div
                *ngIf="isStateDropdownOpen"
                id="stateDropdown"
                class="tw-absolute tw-z-10 tw-w-full tw-mt-2 tw-rounded-2xl tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-left-0 md:tw-right-0 md:tw-left-auto"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="menu-button"
                tabindex="-1"
            >
                <div
                    class="tw-max-h-[225px] tw-overflow-y-auto tw-scrollbar-thin"
                >
                    <button
                        class="tw-px-4 tw-py-4 tw-text-base tw-w-full tw-text-left tw-font-semibold tw-opacity-30"
                        (click)="resetState()"
                        disabled
                    >
                        State
                    </button>
                    <div class="tw-border-t tw-border-gray-200"></div>

                    <ng-container *ngFor="let state of stateOptions">
                        <button
                            class="tw-px-4 tw-py-4 tw-text-base tw-w-full tw-text-left tw-font-semibold tw-transition"
                            [ngClass]="{
                                'tw-bg-[#4B6EEC] tw-text-white':
                                    selectedState === state
                            }"
                            (click)="selectState(state)"
                        >
                            {{ state }}
                        </button>
                        <div class="tw-border-t tw-border-gray-200"></div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div
        class="tw-flex md:tw-justify-start tw-justify-center tw-items-center tw-text-center md:tw-text-left tw-font-[Figtree] tw-text-base tw-font-semibold tw-text-[#6C513A] tw-rounded-2xl tw-py-4 tw-px-5 tw-mt-5 tw-bg-[#FFDEC0]"
    >
        {{
            showPreferredBranchMessage
                ? ("SELECT_BRANCH.PLEASE_SELECT_PREFERRED_BRANCH_AND_OFFICER"
                  | translate)
                : ("SELECT_BRANCH.PLEASE_SELECT_PREFERRED_BRANCH" | translate)
        }}
    </div>
    <ng-container *ngIf="branchDetails?.length > 0; else noSearchResult">
        <div class="tw-flex tw-flex-1 tw-flex-col tw-my-6 tw-gap-4">
            <hr class="tw-h-[1px] tw-bg-[#8D8D8D]" />
            <div
                *ngFor="let item of branchDetails; let i = index"
                class="tw-flex tw-flex-col tw-rounded-xl tw-w-full tw-gap-4"
            >
                <div
                    class="tw-flex tw-gap-4 tw-items-center tw-p-4 tw-rounded-xl"
                    [ngClass]="
                        selectedBranchId === item.branchId
                            ? 'tw-bg-[#003a702d]'
                            : 'tw-bg-transparent'
                    "
                >
                    <input
                        class="tw-cursor-pointer tw-scale-150 tw-accent-[#003A70]"
                        type="radio"
                        name="action"
                        value="{{ i }}"
                        [checked]="selectedBranchId === item.branchId"
                        (change)="onSelectBranch($event, item)"
                    />
                    <div class="tw-flex tw-flex-col tw-gap-2 tw-flex-1">
                        <div class="tw-font-bold tw-text-lg tw-text-[#003A70]">
                            {{ item.branchName }}, {{ item.city }}
                        </div>
                        <div class="tw-font-semibold tw-text-[#6D7A87]">
                            {{ item.description }}
                        </div>
                        <div
                            class="tw-flex tw-justify-between tw-flex-col md:tw-flex-row tw-gap-3"
                            [ngClass]="{
                                'md:tw-justify-between':
                                    item?.fax || item?.email,
                                'md:tw-justify-start tw-gap-40':
                                    !item?.fax && !item?.email
                            }"
                        >
                            <div class="tw-flex tw-items-center">
                                <mat-icon
                                    class="tw-text-sm tw-text-[#6D7A87] tw-content-center"
                                >
                                    access_time
                                </mat-icon>
                                <div class="tw-text-[#6D7A87] tw-text-sm">
                                    {{ item.hours }}
                                </div>
                            </div>
                            <div class="tw-flex tw-items-center">
                                <mat-icon
                                    class="tw-text-sm tw-text-[#6D7A87] tw-content-center"
                                >
                                    phone
                                </mat-icon>
                                <div class="tw-text-[#6D7A87] tw-text-sm">
                                    {{ item.phone }}
                                </div>
                            </div>
                            <div
                                class="tw-flex tw-items-center"
                                *ngIf="item.fax"
                            >
                                <mat-icon
                                    class="tw-text-sm tw-text-[#6D7A87] tw-content-center"
                                >
                                    fax
                                </mat-icon>
                                <div class="tw-text-[#6D7A87] tw-text-sm">
                                    {{ item.fax }}
                                </div>
                            </div>
                            <div
                                class="tw-flex tw-items-center"
                                *ngIf="item.email"
                            >
                                <mat-icon
                                    class="tw-text-sm tw-text-[#6D7A87] tw-content-center"
                                >
                                    mail
                                </mat-icon>
                                <div class="tw-text-[#6D7A87] tw-text-sm">
                                    {{ item.email }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="tw-mt-2 tw-pl-10"
                    *ngIf="
                        item.fiProd == 'IFBU' &&
                        selectedBranchId === item.branchId
                    "
                >
                    <div class="tw-font-semibold tw-text-[#6D7A87]">
                        {{ "SELECT_BRANCH.SELECT_AN_OFFICER" | translate }}
                    </div>
                    <div class="tw-list-none tw-text-[#003A70] tw-mt-4">
                        <div
                            class="tw-flex tw-rounded-xl tw-p-2 sm:tw-items-center tw-gap-4 tw-items-baseline"
                            *ngFor="let officer of item.officer"
                        >
                            <input
                                class="tw-cursor-pointer tw-scale-150 tw-accent-[#003A70]"
                                type="radio"
                                value="{{ i }}"
                                [checked]="
                                    selectedOfficerId === officer.officerId
                                "
                                (change)="onOfficerSelect(officer)"
                            />
                            <div class="tw-flex tw-flex-col">
                                <span
                                    class="tw-font-bold tw-text-lg tw-text-[#003A70]"
                                    >{{ officer.officerName }}</span
                                >
                                <div
                                    class="tw-flex tw-justify-start tw-flex-col md:tw-flex-row tw-gap-2 sm:tw-gap-4"
                                >
                                    <div class="tw-flex tw-items-center">
                                        <mat-icon
                                            class="tw-text-sm tw-text-[#6D7A87] tw-content-center"
                                        >
                                            email
                                        </mat-icon>
                                        <div
                                            class="tw-text-[#6D7A87] tw-text-sm"
                                        >
                                            {{ officer.officerEmail }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="tw-h-[1px] tw-bg-[#8D8D8D]" />
            </div>
        </div>
        <div
            class="tw-sticky tw-left-0 tw-bottom-5 tw-right-0 tw-flex tw-justify-end"
        >
            <button
                class="tw-px-20 tw-py-3 sm:tw-rounded-[32px] tw-rounded-[16px] sm:tw-w-auto tw-w-full tw-bg-[#003A70] tw-text-white"
                (click)="onSubmit()"
            >
                {{ "COMMON.SAVE" | translate }}
            </button>
        </div>
    </ng-container>
    <ng-template #noSearchResult>
        <div
            class="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-base tw-font-semibold tw-text-caption-gray"
        >
            {{ "NEW_APPLICATION.NO_SEARCH_RESULT" | translate }}
        </div>
    </ng-template>
</section>
